import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { PrinterOutlined } from '@ant-design/icons';
import printJS from 'print-js';
import { http } from 'services/http';

interface ITripPrintingProps {
  tripId: number;
}

export const TripPrinting: React.FC<ITripPrintingProps> = (props) => {
  const { tripId } = props;

  const { t } = useTranslation();

  const handleClick = async () => {
    const result = await http.get(`/v1/trips/${tripId}/pdf`);
    printJS({ printable: result.data, type: 'pdf', base64: true });
  };

  return (
    <Button icon={<PrinterOutlined />} onClick={handleClick}>
      {t('trip:print')}
    </Button>
  );
};
